export const view = {
  adjustment: {
    create: 'Crear Ajuste',
    edit: 'Editar Adjuste',
    delete: 'Eliminar Ajuste',
  },
};
